import { WebmotorsBrand } from "../../elements";
import { DrawerProvider } from "../../elements/drawer/providers/drawer.provider";
import styles from "./navbar.module.css";
import type { NavbarProps } from "./navbar.types";
import { NavbarButtons } from "./navbar-buttons";
import { NavbarLinks } from "./navbar-links";
import { NavbarSearch } from "./navbar-search";
import { NavbarProvider } from "./providers";

export function Navbar({
  baseURL,
  renderAutocomplete,
  user,
  onLogout,
  showNotification,
  favoriteVehicles,
  unreadChats,
  returnUrl,
  customGuestLinks,
  searchRightSlot,
  showSearch = true,
  shouldOpenInSameWindow = false,
}: Readonly<NavbarProps>) {
  return (
    <DrawerProvider>
      <NavbarProvider
        baseURL={baseURL}
        renderAutocomplete={renderAutocomplete}
        user={user}
        onLogout={onLogout}
        showNotification={showNotification}
        favoriteVehicles={favoriteVehicles}
        unreadChats={unreadChats}
        returnUrl={returnUrl}
        customGuestLinks={customGuestLinks}
        searchRightSlot={searchRightSlot}
        shouldOpenInSameWindow={shouldOpenInSameWindow}
      >
        <nav className={styles.Navbar} aria-label="Main Navigation">
          <div className={styles.Content}>
            <div className={styles.LeftColumn}>
              <div className={styles.Brand} aria-label="Company Logo">
                <a
                  href={baseURL}
                  title="Webmotors"
                  className={styles.BrandLink}
                >
                  <WebmotorsBrand
                    titleId="company-logo-title"
                    title="Company Logo"
                  />
                </a>
              </div>
              <NavbarLinks />
            </div>

            <div className={styles.RightColumn}>
              {showSearch && <NavbarSearch />}
              <NavbarButtons />
            </div>
          </div>
        </nav>
      </NavbarProvider>
    </DrawerProvider>
  );
}
